export default function ContactHero() {
  return (
    <section className="relative bg-slate-900 pt-28 pb-20 overflow-hidden">
      {/* Background texture */}
      <div className="absolute inset-0 opacity-20"
        style={{ backgroundImage: "radial-gradient(circle at 30% 50%, #f59e0b 0%, transparent 60%), radial-gradient(circle at 80% 20%, #f59e0b 0%, transparent 50%)" }}
      />
      <div className="relative max-w-7xl mx-auto px-6 text-center">
        <span className="inline-block text-yellow-400 text-xs font-bold tracking-[0.25em] uppercase mb-4">
          Support &amp; Hilfe
        </span>
        <h1 className="font-playfair text-5xl md:text-6xl font-bold text-white mb-5 leading-tight">
          Wir sind hier<br />
          <span className="text-yellow-400">um Ihnen zu helfen</span>
        </h1>
        <p className="text-slate-400 text-lg max-w-xl mx-auto leading-relaxed">
          Eine Frage zu Ihrem Los, der Ziehung oder Ihrem Konto? Unser Team antwortet an Werktagen in weniger als 2 Stunden.
        </p>

        {/* Stats row */}
        <div className="flex flex-wrap items-center justify-center gap-8 mt-12">
          {[
            { icon: "ri-time-line", value: "&lt; 2h", label: "Antwortzeit" },
            { icon: "ri-customer-service-line", value: "7/7", label: "Support verfügbar" },
            { icon: "ri-star-fill", value: "4.8/5", label: "Kundenzufriedenheit" },
          ].map((stat) => (
            <div key={stat.label} className="flex items-center gap-3 text-left">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-yellow-400/15">
                <i className={`${stat.icon} text-yellow-400 text-lg`}></i>
              </div>
              <div>
                <p className="text-white font-bold text-base leading-none" dangerouslySetInnerHTML={{ __html: stat.value }} />
                <p className="text-slate-500 text-xs mt-0.5">{stat.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
